import { Toaster } from "@blueprintjs/core";

export const CopyToaster = Toaster.create({
    className: "copy-toaster",
    position: "top"
});

export const ParseToaster = Toaster.create({
    className: "parse-toaster",
    position: "top"
});

export const ScheduleDeleteToaster = Toaster.create({
    className: "schedule-toaster",
    position: "top"
});

export const ScheduleToaster = Toaster.create({
    className: "schedule-toaster",
    position: "top"
});

export const ActionToaster = Toaster.create({
    className: "action-toaster",
    position: "top"
});

export const ActionCardToaster = Toaster.create({
    className: "action-card-toaster",
    position: "top"
});

export const PolicyToaster = Toaster.create({
    className: "policy-toaster",
    position: "top"
});

export const DiagnosticToaster = Toaster.create({
    className: "diagnostic-toaster",
    position: "top"
});
